/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { type HeadersMap, XRPCError } from '@atproto/xrpc'
import { type ValidationResult, BlobRef } from '@atproto/lexicon'
import { CID } from 'multiformats/cid'
import { validate as _validate } from '../../../../lexicons.js'
import {
  type $Typed,
  is$typed as _is$typed,
  type OmitKey,
} from '../../../../util.js'

const is$typed = _is$typed,
  validate = _validate
const id = 'app.bsky.video.startUpload'

export type QueryParams = {}

export interface InputSchema {
  /** Exact byte size of the complete upload-ready video file before it is split into parts. */
  sizeBytes: number
  /** Declared MIME type of the video. */
  mimeType: string
  /** Optional client-provided file name. */
  name?: string
  /** Advisory, non-authoritative duration used only for early failure; the authoritative probe runs asynchronously after upload. */
  durationMs?: number
  /** Advisory, non-authoritative width used only for early failure; the authoritative probe runs asynchronously after upload. */
  width?: number
  /** Advisory, non-authoritative height used only for early failure; the authoritative probe runs asynchronously after upload. */
  height?: number
}

export interface OutputSchema {
  jobId: string
  partSizeBytes: number
  partCount: number
  expiresAt: string
}

export interface CallOptions {
  signal?: AbortSignal
  headers?: HeadersMap
  qp?: QueryParams
  encoding?: 'application/json'
}

export interface Response {
  success: boolean
  headers: HeadersMap
  data: OutputSchema
}

export class UnsupportedContentTypeError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class VideoTooLargeError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class VideoTooLongError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class BadAspectRatioError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class DailyLimitExceededError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class TooManyOpenUploadsError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class UploadForbiddenError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export class ServiceOverloadedError extends XRPCError {
  constructor(src: XRPCError) {
    super(src.status, src.error, src.message, src.headers, { cause: src })
  }
}

export function toKnownErr(e: any) {
  if (e instanceof XRPCError) {
    if (e.error === 'UnsupportedContentType')
      return new UnsupportedContentTypeError(e)
    if (e.error === 'VideoTooLarge') return new VideoTooLargeError(e)
    if (e.error === 'VideoTooLong') return new VideoTooLongError(e)
    if (e.error === 'BadAspectRatio') return new BadAspectRatioError(e)
    if (e.error === 'DailyLimitExceeded') return new DailyLimitExceededError(e)
    if (e.error === 'TooManyOpenUploads') return new TooManyOpenUploadsError(e)
    if (e.error === 'UploadForbidden') return new UploadForbiddenError(e)
    if (e.error === 'ServiceOverloaded') return new ServiceOverloadedError(e)
  }

  return e
}
